export interface ISwapCourier {
    id: number,
    abbreviation: string,
    name: string,
    phone: string,
    isActive: boolean,
    isBillable: boolean,
    isAutoAssignedSwap: boolean
}